<script>
import { formatCompact } from "../../../../../shared/utils/formatters";

export default {
  name: "EmployeeBySex",
  props: {
    sex: {
      type: String,
      required: true,
    },
    total: {
      type: Number,
      required: true,
    },
    percentage: {
      type: String,
      required: true,
    },
  },
  methods: {
    formatCompact
  }
}

</script>

<template>
  <div class="sex-percentage-container">
    <div>
      <img
        v-if="sex == 'men'"
        class="men"
        src="../../../../../assets/icons/dashboard/man.png"
      />
      <img
        v-if="sex == 'women'"
        class="women"
        src="../../../../../assets/icons/dashboard/woman.png"
      />
    </div>
    <div class="sex-details-container">
      <div class="sex-total">{{ formatCompact(total) }}</div>
      <div class="sex-percentage">{{ percentage }}</div>
    </div>
  </div>
</template>
<style scoped>
.sex-percentage-container {
  text-align: center;
  overflow:hidden;
  img {
    height: 115px;
    object-fit: contain;
    transform: translateY(-140px);
  }

  .men {
    filter: drop-shadow(0px 140px 0 #64339A);
  }

  .women {
    filter: drop-shadow(0px 140px 0 #19A39C);
  }

  .sex-total {
    font-size: 24px;
    font-family: Montserrat, sans-serif;
    color: #2F60A6;
  }

  .sex-percentage {
    font-size: 20px;
    font-family: Montserrat, sans-serif;
    color: #2F60A6;
  }

  .sex-name {
    font-size: 12px;
    font-family: Montserrat, sans-serif;
    color: #4f4e4e;
  }

  .sex-details-container {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
  }
}
</style>
